// libs
import React, { useState, memo, useRef } from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

// components
import Image from 'shared/components/Image';

// styles
import { Container } from './styles';

// contexts
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

// constants
import { DWEB_MAX_WIDTH } from 'shared/styles/base';

// def
import { IWidgetItems } from 'shared/components/AdPlatformWidgets/types';

// hooks
import { useTrackingObserver } from 'shared/components/AdPlatformWidgets/ImpressionTracking/trackingHooks';

const GUTTER_SPACE = 10;

interface IVideoProps {
  widgetItem: IWidgetItems;
}

function Video({ widgetItem }: IVideoProps) {
  const { deviceWidth } = useResponsiveContext();
  const [showPlaceholder, setShowPlaceholder] = useState(true);
  const imageSrc = widgetItem.children[0].source;
  const videoSrc = widgetItem.parameters.web_action_url;
  const aspect_ratio = imageSrc.Web_aspect_ratio || 1.7;
  const containerWidth = deviceWidth > DWEB_MAX_WIDTH ? DWEB_MAX_WIDTH : deviceWidth;

  const widgetRef = useRef<HTMLElement>(null);
  const trackingData = get(widgetItem, 'trackingData');
  useTrackingObserver({ widgetRef, trackingData });

  if (isEmpty(videoSrc) && isEmpty(imageSrc)) {
    return null;
  }

  if (showPlaceholder) {
    return (
      <Container>
        <Image
          className="image-placeholder"
          src={imageSrc.Web}
          alt="Video"
          onClick={() => setShowPlaceholder(false)}
          width={containerWidth - GUTTER_SPACE}
          height={containerWidth / aspect_ratio}
        />
      </Container>
    );
  }

  return (
    <Container ref={widgetRef}>
      <iframe
        className="image-placeholder"
        src={videoSrc}
        title="Video"
        width={containerWidth - GUTTER_SPACE}
        height={containerWidth / aspect_ratio}
        frameBorder={0}
      />
    </Container>
  );
}

export default memo(Video);
